import { useCallback, useEffect, useMemo, useState } from "react";
import { IPrimaryData } from "../../../pages/Account/components/View/Admin/HeaderActions/types/PrimaryData";
import CustomersService from "../../../services/customers";

export const useFetchPrimaryData = (
  primaryData: IPrimaryData | undefined,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const [data, setData] = useState<any[]>([]);

  const formattedData = useMemo(() => {
    return primaryData
      ? data.map((item: any) => {
          const { customerCompanyData, customerIndividualData, typeId } = item;

          return {
            id: item.id,
            value: item.id,
            number: item.number,
            name:
              typeId === 2
                ? customerCompanyData.companyName || ""
                : `${customerIndividualData.name1 || ""} ${
                    customerIndividualData.name2 || ""
                  } ${customerIndividualData.name3 || ""}`,
            role: primaryData.buyerId === item.id ? 1 : 2
          };
        })
      : [];
  }, [data, primaryData]);

  const fetchData = useCallback(() => {
    primaryData &&
      Promise.all([CustomersService.get(primaryData.buyerId), CustomersService.get(primaryData.sellerId)])
        .then((res) => {
          setData(res);
          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
  }, [primaryData, setIsLoading]);

  useEffect(() => fetchData(), [fetchData]);

  return { formattedData };
};
